import { render, staticRenderFns } from "./NotasSubmetidas.vue?vue&type=template&id=6620d021"
import script from "./NotasSubmetidas.vue?vue&type=script&lang=js"
export * from "./NotasSubmetidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports